var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterIconIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9258,
    cy: 16,
    r: 16,
    fill: "#D9F5EE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_126_1984)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6549 16.0001C18.6549 16.9559 17.88 17.7308 16.9241 17.7308C15.9683 17.7308 15.1934 16.9559 15.1934 16.0001C15.1934 15.0442 15.9683 14.2693 16.9241 14.2693C17.88 14.2693 18.6549 15.0442 18.6549 16.0001Z",
    fill: "#252A34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8472 10.7693H14.0011C12.7285 10.7693 11.6934 11.8044 11.6934 13.077V18.9231C11.6934 20.1957 12.7285 21.2308 14.0011 21.2308H19.8472C21.1197 21.2308 22.1549 20.1957 22.1549 18.9231V13.077C22.1549 11.8044 21.1197 10.7693 19.8472 10.7693ZM16.9241 18.8847C15.3335 18.8847 14.0395 17.5907 14.0395 16.0001C14.0395 14.4095 15.3335 13.1154 16.9241 13.1154C18.5147 13.1154 19.8087 14.4095 19.8087 16.0001C19.8087 17.5907 18.5147 18.8847 16.9241 18.8847ZM20.2318 13.2693C19.9132 13.2693 19.6549 13.011 19.6549 12.6924C19.6549 12.3737 19.9132 12.1154 20.2318 12.1154C20.5505 12.1154 20.8087 12.3737 20.8087 12.6924C20.8087 13.011 20.5505 13.2693 20.2318 13.2693Z",
    fill: "#252A34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5781 6.15381H12.2704C9.40745 6.15381 7.07812 8.48314 7.07812 11.3461V20.6538C7.07812 23.5168 9.40745 25.8461 12.2704 25.8461H21.5781C24.4411 25.8461 26.7704 23.5168 26.7704 20.6538V11.3461C26.7704 8.48314 24.4411 6.15381 21.5781 6.15381ZM23.3089 18.923C23.3089 20.8317 21.756 22.3846 19.8474 22.3846H14.0012C12.0925 22.3846 10.5397 20.8317 10.5397 18.923V13.0769C10.5397 11.1682 12.0925 9.61535 14.0012 9.61535H19.8474C21.756 9.61535 23.3089 11.1682 23.3089 13.0769V18.923Z",
    fill: "#252A34"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_126_1984"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.6923,
    height: 19.6923,
    fill: "white",
    transform: "translate(7.07812 6.15381)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIconIn);
export default __webpack_public_path__ + "static/media/FooterIconIn.05ec5f371315fa363943ab494e5524c6.svg";
export { ForwardRef as ReactComponent };